import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';

@Component({
  selector: 'app-add-subscription',
  templateUrl: './add-subscription.component.html',
  styleUrls: ['./add-subscription.component.css']
})
export class AddSubscriptionComponent extends BaseComponent implements OnInit {

  customer_id;
  addSubscriptionForm: FormGroup;
  getCompanyobj: any = [];
  status: boolean = true;
  submitted = false;
  constructor(
    private formBuilder: FormBuilder,
    private clientsService: ClientService,
    private masterService:MasterService
  ) {super(); }

  ngOnInit(): void {
    this.customer_id = JSON.parse(sessionStorage.getItem('userData')).admin_customer_id;
    if (this.customer_id == 0) this.getCompany();
    this.addSubscriptionForm = this.formBuilder.group({
      title: ['', [Validators.required, Validators.maxLength(50)]],
      slug_title: ['',[Validators.maxLength(50),Validators.required]],
      subscription_type: ['monthly', Validators.required],
      credits_per_dollar: [200, [Validators.required, Validators.min(0)]],
      trial_30day_value: [''],
      allocate_point:['',Validators.required],
      price:['',Validators.required],
      gst_rate:['',Validators.required],
      half_yearly_discount:[''],
      yearly_discount:[''],
      orderno:[''],
      selectedCompany: [(this.customer_id == 0) ? this.getDefaultCompanyId() : this.customer_id, Validators.required],
      self_referral_point:['',Validators.required],
      ds_referral_point:['',Validators.required]
    });
    this.addSubscriptionForm.get('subscription_type').valueChanges.subscribe(() => {
      this.syncTrialWorthValidators(this.addSubscriptionForm);
    });
    this.syncTrialWorthValidators(this.addSubscriptionForm);
  }
  isTrialPlan(form: FormGroup) {
    return form && form.get('subscription_type') && form.get('subscription_type').value === '14-Days';
  }
  syncTrialWorthValidators(form: FormGroup) {
    const ctrl = form.get('trial_30day_value');
    if (!ctrl) {
      return;
    }
    if (this.isTrialPlan(form)) {
      ctrl.setValidators([Validators.required, Validators.min(0)]);
    } else {
      ctrl.clearValidators();
      if (ctrl.value !== '' && ctrl.value !== null) {
        ctrl.setValue('');
      }
    }
    ctrl.updateValueAndValidity({ emitEvent: false });
  }
  trialFourteenDayWorth(form: FormGroup) {
    const worth = Number(form.get('trial_30day_value').value);
    if (!isFinite(worth) || worth < 0) {
      return '0.00';
    }
    return (worth * 14 / 30).toFixed(2);
  }
  trialSignupCredits(form: FormGroup) {
    const worth = Number(form.get('trial_30day_value').value);
    const rate = Number(form.get('credits_per_dollar').value);
    if (!isFinite(worth) || !isFinite(rate) || worth < 0 || rate < 0) {
      return 0;
    }
    return Math.round(worth * 14 / 30 * rate);
  }
  getCompany() {
    let self = this;
    this.clientsService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      const working = self.bindWorkingCompany(self.getCompanyobj);
      if (working && !self.addSubscriptionForm.value.selectedCompany) {
        self.addSubscriptionForm.patchValue({ selectedCompany: working });
      }
    }, error => {
      console.log(error);
    });
  }
  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  get f() { return this.addSubscriptionForm.controls; }
  addNewSubscriptionData(){
    this.submitted = true;
    if (this.addSubscriptionForm.invalid) {
      return;
    }
    let { selectedCompany } = this.addSubscriptionForm.value;
    this.masterService.addSubscriptionCategory(this.addSubscriptionForm.value,selectedCompany).subscribe(data=>{
      if (data.status) {
        this.toastrService.success("Subscription added successfully");
        this.router.navigateByUrl(`/corporate/subscription-list`);
      } else {
        this.toastrService.error(data.message);
      }
    },error => {
      this.toastrService.error(error.message);
    });
  }

}
